import { Box } from '@mui/system';
import React, { ReactNode } from 'react';

export type CSummaryCardProps = { title: string; content: string | ReactNode };
export const CSummaryCard = (props: CSummaryCardProps) => {
	const { title, content } = props;
	return (
		<Box
			sx={{
				color: '#FFFFFF',
				fontFamily: 'Poppins',
				borderRadius: '10px',
				backgroundColor: '#1A2B48',
				padding: '1.5rem',
				height: '100%',
			}}
		>
			<Box
				sx={{
					fontSize: '1rem',
					fontWeight: '500',
				}}
			>
				{title}
			</Box>
			<Box
				sx={{
					fontSize: '2rem',
					fontWeight: '600',
				}}
			>
				{content}
			</Box>
		</Box>
	);
};
